module.exports = __webpack_public_path__ + "img/9791156550341.84937a55.jpg";